import { ChangeEvent } from 'react'
import Checkbox from '../../../../../../components/Checkbox'
import { LabelInline } from '../../../../../../components/FormUtilities'
import { RCProps } from './types'
import { formLogisticalCost } from '../../storageStep2'

export default function RC(props: RCProps) {
    function onChange(ev: ChangeEvent<HTMLInputElement>) {
        const checked = ev.target.checked
        const { rcs } = formLogisticalCost.store()
        if (!checked) {
            const rcsFiltered = rcs.filter(rc => rc.value !== props.value)
            formLogisticalCost.setValue('rcs', rcsFiltered)
            formLogisticalCost.setValue('productIds', [], false)
        } else {
            if (!rcs.find(rc => rc.value === props.value)) {
                formLogisticalCost.setValue('rcs', [
                    ...rcs,
                    { value: props.value, label: props.label }
                ])
            }
        }
    }

    return (
        <LabelInline label={props.label} className="mb-2">
            <Checkbox checked={props.checked} onChange={onChange} disabled />
        </LabelInline>
    )
}
